import request from "@/utils/request";

// 登录方法
export function login(userName, password,domain,code, uuid) {
  return request({
    url: "system/login",
    method: "post",
    data: {
      userName,
      password,
      domain,
      code,
      uuid,
    },
  });
}
//手机号码登录
export function loginPhone(phone, phoneCode) {
  return request({
    url: "system/phone-login",
    method: "post",
    data: {
      phone, 
      phoneCode
    },
  });
}
// 获取用户详细信息
export function getInfo() {
  return request({
    url: "/system/user/get-info",
    method: "get",
  });
}
// 退出方法
export function logout() {
  return request({
    url: "system/logout",
    method: "delete",
  });
}
// 获取验证码
export function getCodeImg() {
  return request({
    url: 'code',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

//短信发送
export function sendSms(data) {
  return request({
    url: 'system/phone-code',
    method: 'post',
    data: data
  })
}